import type { HuntType } from './hunt-type'
import type { SchedulableLocationType } from './schedule'
import type { TimeBlock, TimeBlockPeriod } from './time-block'

export type LocationHuntRuleDefaults = {
  huntCutoffHours: number | null
  maxDaysOut: number | null
  maxActiveHunts: number | null
  maxActiveHuntsBypassHours: number | null
  daysPerHunt: number | null
}

export type LocationHuntRules = {
  locationType: SchedulableLocationType
  locationId: string
  huntCutoffHours: number | null
  maxDaysOut: number | null
  maxActiveHunts: number | null
  maxActiveHuntsBypassHours: number | null
  daysPerHunt: number | null
  timeBlocks: TimeBlock[]
  orgDefaults: LocationHuntRuleDefaults
}

export type LocationTimeBlockInput = {
  id?: string
  huntType: HuntType
  name: string
  startTime: string
  endTime: string
  timePeriod: TimeBlockPeriod
  enabled: boolean
  displayOrder: number
}

export type LocationHuntRulesInput = {
  huntCutoffHours: number | null
  maxDaysOut: number | null
  maxActiveHunts: number | null
  maxActiveHuntsBypassHours: number | null
  daysPerHunt: number | null
  timeBlocks: LocationTimeBlockInput[]
}

export const UNCONFIGURED_LOCATION_HUNT_RULES: LocationHuntRulesInput = {
  huntCutoffHours: null,
  maxDaysOut: null,
  maxActiveHunts: null,
  maxActiveHuntsBypassHours: null,
  daysPerHunt: null,
  timeBlocks: [],
}
